import { render, staticRenderFns } from "./LimparPosicoes.vue?vue&type=template&id=4abe9856"
import script from "./LimparPosicoes.vue?vue&type=script&lang=js"
export * from "./LimparPosicoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports